import { FC, ChangeEvent/* , useState */ } from 'react'

import { Text, Select } from '../../UI'

type FamilyGroupFilterProps = {
  data: any[],
  dataSelected?: string,
  text?: string,
  onChange(id: string): void
}

const FamilyGroupFilter:FC<FamilyGroupFilterProps> = ({ data, dataSelected, text = 'Información de', onChange }) => {
  const onFilterChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target
    onChange(value)
  }

  return (
    <div className="d-flex flex-column lg:flex-row lg:justify-content-end lg:align-items-center">
      <Text component="label" size="13" className="lg:d-inline">{text}</Text>
      <div className="family-group-filter mt-5 lg:mt-0 lg:ml-5 ">
        <Select
          version="2"
          fullWidth
          value={dataSelected}
          onChange={onFilterChange}
        >
          {data && data.length > 0 && data.map((it: any, i: number) => {
            return (
              <option key={i} value={it.id}>{`${it.name}`}</option>
            )
          })}
        </Select>
      </div>
    </div>
  )
}

export { FamilyGroupFilter }